<template>
    <div class="report">
        <v-container fluid class="white">
            <v-container fluid class="">
                 <v-snackbar
                v-model="snackbar"
                :vertical="vertical"
                top
                >
                {{ feedback }}
                <v-btn
                    color="primary"
                    text
                    @click="snackbar = false"
                >
                    Close
                </v-btn>
                </v-snackbar>
                <v-row dense justify="center" justify-sm="start" align="center" class="" no-gutters>
                    <v-col xs="6" sm="4" md="3" lg="3">
                        <v-img class="img"
                        src="../../assets/YourConcierge.jpg"
                        max-height="50"
                        contain
                        ></v-img>
                        
                    </v-col>
                    <v-spacer class="d-none d-sm-flex"></v-spacer>
                    <v-col cols="auto" v-if="creation_date" class="mx-2 d-none d-sm-flex">
                        <p class="info--text">{{creation_date}}</p>
                    </v-col>
                    <v-col cols="auto" v-if="ticket_id" class="mx-2 d-none d-sm-flex">
                        <p class="info--text">No.{{ticket_id}}</p>
                    </v-col>
                </v-row>
            </v-container>
            <v-divider light class="primary"></v-divider>
            <v-container fluid class="mt-3">
                <!-- <v-row justify="center">
                    <v-avatar right size="100" class="grey lighten-2">
                        <img :src="avatarURL" alt="">
                    </v-avatar>
                </v-row>
                <v-row justify="center" class="mt-4 caption">
                    <p class="info--text">{{name}}</p>
                </v-row> -->
                <v-row justify="start" class="mt-4">
                    <v-col cols="12">
                        <v-card flat class="d-flex flex-wrap pa-2">
                            <v-card-text class="richtext mx-3" v-html="richtext"></v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row dense no-gutters justify="end" align="center" class="mt-2" v-if="first_editor.signatureURL">
                    <v-col cols="1" class="">
                        <v-img
                            :src="first_editor.signatureURL"
                            max-height="45"
                            contain
                            class="white"
                            ></v-img>
                    </v-col>
                    <v-col cols="auto" v-if="first_editor.avatarURL" class="mx-3">
                        <v-avatar right size="60" class="primary lighten-2">
                            <img :src="first_editor.avatarURL" alt="">
                        </v-avatar>
                    </v-col>
                </v-row>
                <v-row dense no-gutters justify="end" align="center" class="mt-2" v-if="second_editor.signatureURL">
                    <v-col cols="1" class="">
                    <v-img
                        :src="second_editor.signatureURL"
                        max-height="45"
                        contain
                        class="white"
                        ></v-img>
                    </v-col>
                    <v-col cols="auto" v-if="second_editor.avatarURL" class="mx-3">
                        <v-avatar right size="60" class="primary lighten-2">
                            <img :src="second_editor.avatarURL" alt="">
                        </v-avatar>
                    </v-col>
                </v-row>
                <v-container>
                    <v-row justify="center" align="center" class="text-center">
                        <span class="mb-5">twitter・noteで最新情報を発信しています。ぜひフォローして下さい。<br>Follow us and stay up to date. </span>
                    </v-row>
                    <v-row justify="center" align="center">
                        <a href="https://www.facebook.com/TPOInc/">
                             <v-img src="../../assets/ico_fb.png" max-height="20" contain></v-img>
                        </a>
                        <a href="https://twitter.com/TPO_Concierge">
                            <v-img src="../../assets/ico_twi.png" max-height="20" contain></v-img>
                        </a>
                        <a href="https://note.com/tpo_concierge">
                            <v-img src="../../assets/ico_note.png" max-height="20" contain></v-img>
                        </a>
                        
                    </v-row>
                </v-container>
 
            </v-container>
            <v-row class="mt-3">
                <v-img
                src="../../assets/banner.jpg"
                max-height="45"
                contain
                class="white"
                ></v-img>
            </v-row>
            <v-divider light class="primary"></v-divider>
            <v-row no-gutters v-if="user" class="mt-5 d-flex justify-center">
                <v-col cols="auto" class="mx-1">
                    <v-btn small color="primary info--text" @click="getShareLink">リンクを取得する</v-btn>
                </v-col>
                <v-col cols="auto" class="mx-1">
                    <v-btn small @click="changeStatus">終了時間を記録する</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" class="info--text mt-4">
                <p v-if="link2Share">{{link2Share}}</p>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import {db,auth} from '@/fb'
export default {
    components:{
    },
    data(){
        return {
            ticket_id:null,
            creation_date:null,

            snackbar:false,
            feedback:null,
            vertical: true,

            link2Share:null,
            
            user:null,
            first_editor:{
                avatarURL:null,
                name: null,
                signatureURL:null,
                email:null,
            },
            second_editor:{
                avatarURL:null,
                name: null,
                signatureURL:null,
                email:null,
            },
            richtext:'',
        }
    },
    computed:{
 
    },
    methods:{
        changeStatus(){
            let ref = db.collection('reports').doc(String(this.$route.params.id))
            ref.set({
                handInTime: Date.now(),
                status: 'completed',
            },{ merge: true })
            .then(()=>{
                this.feedback = "時間を記録しました。レポート作成、お疲れ様でした：）"
                this.snackbar = true
            })
            .catch(err=>{
                this.feedback = "エラーが発生しました。。"
                this.snackbar = true
                /* eslint-disable no-console */
                console.log(err)
                /* eslint-enable no-console */
            })
        },
        getShareLink(){
            this.link2Share = 'https://knowledge.yourconcierge.jp'+this.$route.fullPath
            navigator.clipboard.writeText(this.link2Share)
            .then(()=>{
                alert("リンクがコピーされました、そのまま貼り付けてください. Link has been copied.")
            })
            let ref = db.collection('reports').doc(String(this.$route.params.id))
            ref.set({
                report_link : this.link2Share
            },{ merge: true })
            .catch(err=>{
                this.feedback = "エラーが発生しました。。"
                this.snackbar = true
                /* eslint-disable no-console */
                console.log(err)
                /* eslint-enable no-console */
            })
        }
    },
    async created(){
        auth.onAuthStateChanged((user)=>{
            if(user){
                this.user = user
            }else{
                this.user = null
            }
        })

        let res = await db.collection('reports').doc(String(this.$route.params.id)).get()
        this.first_editor.email = res.data().editor
        this.second_editor.email = res.data().second_editor
        this.richtext = res.data().report_comment

        let ref = db.collection('users')

        ref.where("email","==",this.first_editor.email).get()
        .then(snap=>{
            snap.forEach(doc=>{
               this.first_editor.avatarURL = doc.data().avatar 
               this.first_editor.name = doc.data().name
               this.first_editor.signatureURL=doc.data().signature
            })
        })
        .catch(err=>{
            /* eslint-disable no-console */
            console.log(err)
            /* eslint-enable no-console */
        })

        ref.where("email","==",this.second_editor.email).get()
        .then(snap=>{
            snap.forEach(doc=>{
               this.second_editor.avatarURL = doc.data().avatar 
               this.second_editor.name = doc.data().name
               this.second_editor.signatureURL=doc.data().signature
            })
        })
        .catch(err=>{
            /* eslint-disable no-console */
            console.log(err)
            /* eslint-enable no-console */
        })
    },
    mounted(){
        this.ticket_id= this.$route.params.ticket_id;
        var today = new Date();
        this.creation_date = today.toISOString().substring(0, 10);
    }
}
</script>

<style>
    .v-application p {
        margin-bottom: 0px !important;
    }
    .v-application a {
        color: rgb(44,92,197) !important;
    }
    .v-divider {
        border-width: 2px
    }
    .richtext {
        color:black !important;
    }
</style>